import { Divider, Stack } from '@mui/material';
import type {
  InventoryResource,
  Snapshot,
  AzureVmDisk,
} from '@repo/api-gw-sdk';

import { useWorkspace } from '@/contexts/useWorkspace';

import { SnapshotDetails } from './snapshotDetails';
import type { RestoreActionType, VMSnapshotRowProps } from './vmSnapshotRow';

import { Panels } from '../../panels';
import type { PanelTypes } from '../../panelsMap';

export const AzureVMSnapshotRow = ({
  snap,
  vault,
  isSelected,
  onSelect,
  resource,
  snapshotSelection,
}: VMSnapshotRowProps) => {
  const { setComponent } = useWorkspace().rightPanel;
  return (
    <Stack data-testid='vm-snapshot-row' key={snap.id} className='w-full'>
      <SnapshotDetails
        resource={resource}
        key={snap.id}
        isSelected={isSelected}
        onSelect={onSelect}
        snap={snap}
        vault={vault}
        snapshotSelection={snapshotSelection}
        onRestore={(volumes, actionType) =>
          onAzureRestore(
            volumes.filter((x) => 'diskTier' in x),
            actionType,
            setComponent,
            snap,
            resource
          )
        }
      />
      <Divider />
    </Stack>
  );
};

const onAzureRestore = (
  vols: AzureVmDisk[],
  actionType: RestoreActionType,
  setComponent: (component: PanelTypes) => void,
  snap: Snapshot,
  entity: InventoryResource
) => {
  if (vols.length === 0) {
    return;
  }

  switch (actionType) {
    case 'full-instance':
      setComponent({
        panel: Panels.RestoreAzureVMWizard,
        props: {
          snapshot: snap,
          resource: entity,
        },
      });
      break;
    case 'volume':
      setComponent({
        panel: Panels.RestoreAzureDiskWizard,
        props: {
          snapshot: snap,
          resource: entity,
          disk: vols[0],
        },
      });
  }
};
